import React from "react"
import PropTypes from "prop-types"

import IdVerificationFilter from './sections/IdVerificationFilter';
import AgeFilter from './sections/AgeFilter';
import GenderFilter from './sections/GenderFilter';
import LocationFilter from './sections/LocationFilter';

class WhoCanContactMeContainer extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      gender_id: '',
      min_age_difference: '',
      max_age_difference: '',
      local_chats_only: '',
      loaded: false,
      timeout: null
    }
    this.updateGender = this.updateGender.bind(this)
    this.updateProSettings = this.updateProSettings.bind(this)
    this.updateAge = this.updateAge.bind(this)
    this.toggleIdVerification = this.toggleIdVerification.bind(this)
    this.updateLocation = this.updateLocation.bind(this)
  }

  componentDidMount(){
    this.setState({
      gender_id: this.props.pro_settings != null ? this.props.pro_settings.gender_id : 1,
      min_age_difference: (this.props.pro_settings != null && this.props.pro_settings.min_age_difference != null) ? this.props.pro_settings.min_age_difference : 18,
      max_age_difference: (this.props.pro_settings != null && this.props.pro_settings.max_age_difference != null) ? this.props.pro_settings.max_age_difference : 152,
      local_chats_only: this.props.current_user.local_chats_only,
      loaded: true
    })
  }

  updateGender(gender_id) {
    if(gender_id != this.state.gender_id) {
      let data = {
        gender_id: gender_id
      }
      this.setState({
        gender_id: gender_id
      })
      this.updateProSettings(data)
    }
  }

  updateProSettings(data) {
    $.ajax({
      url: `/ajaxUpdateProSettings`,
      dataType: 'JSON',
      type: 'POST',
      jsonp: 'callback',
      header: {
        'Content-Type': 'application/json'
      },
      data: data,
      success: function(data) {
        this.setState({
          min_age_difference: JSON.parse(data.data.pro_settings).min_age_difference,
          max_age_difference: JSON.parse(data.data.pro_settings).max_age_difference,
          gender_id: JSON.parse(data.data.pro_settings).gender_id
        })
      }.bind(this),
      error: function(xhr, status, err) {
        console.log(`error is ${err}`)
      }.bind(this)
    });
  }

  updateAge(min_age, max_age) {

    if(this.props.premiumUser) {

      this.setState({
        min_age_difference: min_age,
        max_age_difference: max_age
      })

      const { timeout } = this.state;
      clearTimeout(timeout);
      this.setState({
        timeout: setTimeout(() => {
          let data = {
            min_age_difference: min_age,
            max_age_difference: max_age
          }
          this.updateProSettings(data)
        }, 1000)
      })
    }
  }

  toggleIdVerification() {
    this.props.updateIdVerification()
  }

  updateLocation(value) {
    this.setState({
      local_chats_only: value
    })
    this.props.updateUserSettings('local_chats_only', value)
  }

  render() {
    if(!this.state.loaded) {
      return null
    }
    return(
      <div style={{backgroundColor: '#FCFCFC', right: 0, padding: 20}}>
        <LocationFilter
          updateLocation={this.updateLocation}
          locals_only={this.state.local_chats_only}
          filter={false}
        />
        <div className="sectionDivider"></div>
        <GenderFilter
          selectedGender={this.state.gender_id}
          userGender={this.props.current_user.gender_id}
          toggleProModal={this.props.toggleProModal}
          premiumUser={this.props.premiumUser}
          updateGender={this.updateGender}
           />
        <div className="sectionDivider"></div>
        <AgeFilter
          min_age_difference={this.state.min_age_difference}
          max_age_difference={this.state.max_age_difference}
          current_user={this.props.current_user}
          updateAge={this.updateAge}
          premiumUser={this.props.premiumUser}
          toggleProModal={this.props.toggleProModal}
        />
        <div className="sectionDivider"></div>
        <IdVerificationFilter
          idVerification={this.props.idVerification}
          selected={this.props.current_user.verified_chats_only}
          toggleProModal={this.props.toggleProModal}
          toggleIdVerification={this.toggleIdVerification}
         />
      </div>
    )
  }
}

export default WhoCanContactMeContainer;
